import React, { Component } from "react";
class SceneTitle extends Component {

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }
    state = {
        title: this.props.name
    }
    componentDidMount() {
        const { sceneID, css } = this.props;
        document.addEventListener("mousedown", this.handleClickOutside);
        //this.onUpdate(sceneID, css)

    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    onUpdate = (sceneID, css) => {
        let input = document.getElementById('react-input-scene-title');
        input.focus();
        if (input) {
            let timeout = null;
            input.addEventListener('keyup', e => {
                clearTimeout(timeout);
                timeout = setTimeout(() => this.props.sceneUpdateTitle(sceneID, input.value, css, this.onCallBack), 1000);
            });
        }
    }

    onCallBack = () => this.props.onClickToHideSave();
    onChange = event => {
        this.setState({ title: event.target.value })

    }
    handleClickOutside = e => {
        if (!this.myRef.current.contains(e.target)) {
            const { sceneID, css } = this.props;
            const { title } = this.state;
            if (title) this.props.sceneUpdateTitle(sceneID, title, css, this.onCallBack)
            //this.props.onClickToHideSave()
        }
    };

    render() {
        const { title } = this.state;
        return <>
            <div className="scene_content_label sc-eggNIi ezaVln d-flex align-items-center justify-content-center flex-column" value="60000" >
                <input ref={this.myRef} id="react-input-scene-title" type="text" className="input form-control" value={title} onChange={this.onChange} onReset={this.onCallEvn} />
            </div>
        </>
    }

}
export default SceneTitle;